import type { Permissions } from "./permissions";
import type { CustomerLicence } from "./session";

export type FirebaseAuth = {
  url: string | null;
  token: string | null;
  expires: string | null;
  uid: string | null;
};

export type AuthAttributes = {
  eventFilters: string[];
  customerLicence: CustomerLicence | null;
  zendeskDomainTemp: string;
  zendeskKeyTemp: string;
  zendeskDomain: string;
  zendeskKey: string;
  zendeskMessengerToken: string;
};

export const DEFAULT_ATTRIBUTES: AuthAttributes = {
  eventFilters: [],
  customerLicence: null,
  zendeskDomainTemp: "",
  zendeskKeyTemp: "",
  zendeskDomain: "",
  zendeskKey: "",
  zendeskMessengerToken: "",
};

export type ZendeskTemp = {
  zendeskDomain: string;
  zendeskKey: string;
};

export type GuestSession = {
  permissions: Permissions;
  attributes: AuthAttributes;
  lastRefreshedAt: number;
};

export type AuthedSession = GuestSession & {
  sessionId: string;
  userId: string;
  token: string;
  expiresAt: number;
  firebase: FirebaseAuth;
};

export const isAuthed = (state: { status: string }): state is {
  status: "authenticated" | "impersonating";
  session: AuthedSession;
} => state.status === "authenticated" || state.status === "impersonating";
